export const productTypeSelectorId = 'productTypeSelector' // pricing hero에서 수업권 보기 클릭시 스크롤 다운하기 위한 id
